<template>
	<el-dialog v-if="first" :title="'ACTION REQUIRED (' + first.name + ')'" :visible="pending && dialogVisible" width="700px">
		<span>
			{{ first.name }} is requesting access to your school. Once approved, {{ first.name }} will have full administrator access to your Wonde portal, including
			the ability to:
			<ul class="ml-4 mt-3">
				<li>See all applications with access, or are requesting access to your school’s data</li>
				<li>See details of the permissions requested by applications</li>
				<li>Approve/decline applications requesting access to your school’s data</li>
				<li>Revoke applications who have access to your school’s data</li>
				<li>View name and contact details of school data subjects</li>
			</ul>
		</span>
		<span slot="footer" class="dialog-footer">
			<el-button type="danger" :loading="loading" @click="decline">Decline</el-button>
			<el-button type="success" :loading="loading" @click="confirm">Approve</el-button>
		</span>
	</el-dialog>
</template>
<script>
import {
	SchoolOrganisationsQuery,
	SchoolApproveAccessForOrganisationMutation,
	SchoolDeclineAccessForOrganisationMutation,
} from "@/components/apps/appsList/cards/admin/OrganisationPendingNoticeQueries.gql";
import { filter } from "lodash";
import tracker from "@/utils/event-tracker";

export default {
	data() {
		return {
			organisations: null,
			dialogVisible: true,
			loading: false,
		};
	},
	computed: {
		pending() {
			if (this.organisations) {
				return filter(this.organisations, (r) => r.approved_at === null && r.declined_at === null);
			}

			return [];
		},
		first() {
			if (this.pending && this.pending.length) {
				return this.pending[0].Organisation;
			}

			return null;
		},
	},
	apollo: {
		organisations: {
			query: SchoolOrganisationsQuery,
			update: (r) => r.User.School.Organisations,
		},
	},
	methods: {
		confirm() {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: SchoolApproveAccessForOrganisationMutation,
					variables: {
						organisationUuid: this.first.uuid,
					},
					update: (store) => {
						const newstore = store.readQuery({
							query: SchoolOrganisationsQuery,
						});
						newstore.User.School.Organisations = [];
						store.writeQuery({
							query: SchoolOrganisationsQuery,
							data: {
								User: newstore.User,
							},
						});
					},
				})
				.then(() => {
					this.dialogVisible = false;
					this.loading = false;
					this.$message({
						type: "success",
						message: "Approved",
					});
					tracker("organisation-approve", this.first);
				})
				.catch((e) => {
					console.error("error", e);

					this.loading = false;
					this.$message({
						type: "error",
						message: "There was an error performing this action.",
					});
				});
		},
		decline() {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: SchoolDeclineAccessForOrganisationMutation,
					variables: {
						organisationUuid: this.first.uuid,
					},
				})
				.then(() => {
					this.dialogVisible = false;
					this.loading = false;
					this.$message({
						type: "success",
						message: this.first.name + " declined",
					});
					tracker("organisation-declined", this.first);
				})
				.catch((e) => {
					console.error("error", e);

					this.loading = false;
					this.$message({
						type: "error",
						message: "There was an error performing this action.",
					});
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/OrganisationPendingNotice.vue